import React from 'react';
import {useIntl} from 'react-intl';
import {ALIGN, Text, View} from '@lookiero/aurora';

const LOCALE_KEY = {id: 'fb.bottom.trademark'};

export const Copyright: React.FC = () => {
  const {formatMessage} = useIntl();

  return (
    <>
      {Array.from({length: 15}).map((_, i) => (
        <View key={i} testID="fb-space">
          <Text>&zwnj;</Text>
        </View>
      ))}
      <Text align={ALIGN.CENTER} as="p" detail>
        {formatMessage(LOCALE_KEY, {year: new Date().getFullYear()})}
      </Text>
    </>
  );
};
